import React, { useContext } from 'react';
import { BasketContext } from 'src/components/Basket/BasketContext';

import { MessagesModal } from '../Modal/MessagesModal';

export const BasketModalConnected: React.FC = () => {
    const { itemMessages, clearItemMessages } = useContext(BasketContext);
    if (!Array.isArray(itemMessages) || itemMessages.length === 0) {
        return null;
    }
    return (
        <MessagesModal
            close={clearItemMessages}
            messages={itemMessages}
            title="There was a problem with that request"
        />
    );
};
